/*
 * Site novo Burst: comportamento da PDP (seção bst-pdp-compra e botões da tabela nutricional em outras seções).
 * - Kits: troca preço, "De" riscado, % OFF, parcela do 12x, preço no Pix, cashback, preço da barra fixa e o name="id"
 *   do formulário nativo do tema.
 * - Barra fixa (celular): aparece quando o botão de compra já passou da tela; o botão dela envia o mesmo formulário.
 * - Galeria: miniaturas levam à foto; o arraste da principal marca a miniatura.
 * - Stories: só a capa carrega; o toque abre o vídeo em tela cheia (fechar, Esc, arrastar para baixo no celular)
 *   e registra o toque no dataLayer (bst_story_toque) e no Clarity.
 * - Pop-up da tabela: qualquer [data-bst-tabela-abrir] da página abre o [data-bst-tabela-dialog].
 * Sem dependências. Roda de novo quando o editor do tema recarrega a seção.
 */
(function () {
  'use strict';

  function travarRolagem(sim) {
    document.documentElement.style.overflow = sim ? 'hidden' : '';
  }

  function abrirDialogo(d) {
    if (!d || d.open) return;
    /* imagens guardadas em <template> (ex.: arte da tabela) só entram quando o pop-up abre */
    d.querySelectorAll('[data-bst-tabela-img] > template').forEach(function (m) { m.parentNode.appendChild(m.content.cloneNode(true)); m.remove(); });
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    travarRolagem(true);
  }

  function fecharDialogo(d) {
    if (!d) return;
    if (typeof d.close === 'function' && d.open) d.close(); else d.removeAttribute('open');
    travarRolagem(false);
  }

  /* ---------- pop-up da tabela nutricional (um por página, aberto de qualquer seção) ---------- */
  function iniciarTabela() {
    if (window.__bstTabelaPronta) return;
    window.__bstTabelaPronta = true;
    document.addEventListener('click', function (e) {
      var abrir = e.target.closest && e.target.closest('[data-bst-tabela-abrir]');
      if (abrir) {
        var d = document.querySelector('[data-bst-tabela-dialog]');
        if (d) { e.preventDefault(); abrirDialogo(d); }
        return;
      }
      var fechar = e.target.closest && e.target.closest('[data-bst-tabela-fechar]');
      if (fechar) { fecharDialogo(fechar.closest('dialog')); return; }
      if (e.target.matches && e.target.matches('[data-bst-tabela-dialog]')) fecharDialogo(e.target);
    });
    document.addEventListener('close', function (e) {
      if (e.target.matches && e.target.matches('[data-bst-tabela-dialog]')) travarRolagem(false);
    }, true);
  }

  function esconderBotoesSemTabela() {
    var tem = !!document.querySelector('[data-bst-tabela-dialog]');
    document.querySelectorAll('[data-bst-tabela-abrir]').forEach(function (b) { b.hidden = !tem; });
  }

  /* ---------- seção de compra ---------- */
  function iniciarCompra(raiz) {
    if (!raiz || raiz.dataset.bstPronto) return;
    raiz.dataset.bstPronto = '1';

    var form = raiz.querySelector('form');
    var campoId = form ? form.querySelector('input[name="id"]') : null;
    var preco = raiz.querySelector('[data-bst-preco]');
    var deLinha = raiz.querySelector('[data-bst-de-linha]');
    var de = raiz.querySelector('[data-bst-de]');
    var off = raiz.querySelector('[data-bst-off]');
    var parcela = raiz.querySelector('[data-bst-parcela]');
    var cashback = raiz.querySelector('[data-bst-cashback]');
    var precosPix = Array.prototype.slice.call(raiz.querySelectorAll('[data-bst-preco-pix], [data-bst-fixo-preco]'));
    var opcoes = Array.prototype.slice.call(raiz.querySelectorAll('[data-bst-opcao]'));

    function escreverCashback(valor) {
      if (!cashback || !cashback.dataset.modelo) return;
      var partes = cashback.dataset.modelo.split('[valor]');
      cashback.textContent = '';
      partes.forEach(function (p, i) {
        if (i > 0) { var forte = document.createElement('strong'); forte.textContent = valor; cashback.appendChild(forte); }
        cashback.appendChild(document.createTextNode(p));
      });
    }

    function aplicar(r) {
      opcoes.forEach(function (x) { x.closest('.bst-pdp-compra__opcao').classList.toggle('is-ativa', x === r); });
      if (!r.dataset.preco) return;
      if (preco) preco.textContent = r.dataset.preco;
      precosPix.forEach(function (x) { x.textContent = r.dataset.preco; });
      if (de) de.textContent = r.dataset.de;
      if (off) off.textContent = r.dataset.off;
      if (deLinha) deLinha.hidden = !r.dataset.de;
      if (parcela && r.dataset.parcela) parcela.textContent = r.dataset.parcela;
      escreverCashback(r.dataset.cashback);
      if (campoId) campoId.value = r.value;
      trocarFoto(r);
    }
    /* 1º slide da galeria = foto da opção escolhida */
    function trocarFoto(r) {
      var img = raiz.querySelector('[data-bst-foto-opcao] img');
      if (!img || !r.dataset.fotoSrc || img.getAttribute('src') === r.dataset.fotoSrc) return false;
      img.srcset = r.dataset.fotoSrcset || '';
      img.src = r.dataset.fotoSrc;
      var mini = raiz.querySelector('[data-bst-mini-opcao] img');
      if (mini && r.dataset.fotoMini) { mini.removeAttribute('srcset'); mini.src = r.dataset.fotoMini; }
      return true;
    }
    function voltarParaFotoDaOpcao() {
      var g = raiz.querySelector('[data-bst-galeria]');
      if (g && raiz.querySelector('[data-bst-foto-opcao]') && g.scrollLeft > 0) g.scrollTo({ left: 0, behavior: 'smooth' });
    }
    opcoes.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) { aplicar(r); voltarParaFotoDaOpcao(); } });
      /* clique na opção que já estava marcada também mostra a foto dela */
      r.addEventListener('click', function () { if (r.checked) { trocarFoto(r); voltarParaFotoDaOpcao(); } });
    });
    /* volta do cache do navegador: o rádio marcado pode não ser o do HTML */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return; /* na abertura normal o HTML já vem certo (e a 1ª foto pode ser a do produto) */
      var r = raiz.querySelector('[data-bst-opcao]:checked'); if (r) aplicar(r);
    });

    /* quantidade */
    var qtd = raiz.querySelector('[data-bst-qtd-campo]');
    raiz.querySelectorAll('[data-bst-qtd]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qtd.value, 10) || 1) + parseInt(b.dataset.bstQtd, 10);
        qtd.value = Math.max(1, Math.min(99, n));
      });
    });

    /* erro do carrinho (o tema dispara cart:error no formulário) */
    var erro = raiz.querySelector('[data-bst-erro]');
    if (form && erro) {
      form.addEventListener('cart:error', function (e) { erro.textContent = (e.detail && e.detail.error) || 'Não foi possível adicionar ao carrinho.'; erro.hidden = false; });
      form.addEventListener('variant:add', function () { erro.hidden = true; });
    }

    /* acordeões: abertos no computador (se marcados), fechados no celular */
    if (window.matchMedia('(max-width: 999px)').matches) {
      raiz.querySelectorAll('[data-bst-fecha-no-celular]').forEach(function (d) { d.open = false; });
    }

    /* galeria: miniaturas levam à foto; o arraste marca a miniatura */
    var galeria = raiz.querySelector('[data-bst-galeria]');
    var minis = Array.prototype.slice.call(raiz.querySelectorAll('[data-bst-mini]'));
    /* fotos adiadas (3ª em diante): baixam no primeiro contato com a galeria ou com as miniaturas */
    var adiadas = Array.prototype.slice.call(raiz.querySelectorAll('img[data-bst-adiada]'));
    function carregarAdiadas() {
      adiadas.forEach(function (i) {
        if (i.dataset.srcset) i.srcset = i.dataset.srcset;
        if (i.dataset.src) i.src = i.dataset.src;
        i.removeAttribute('data-bst-adiada');
      });
      adiadas = [];
    }
    if (adiadas.length) {
      var gatilhos = [galeria, raiz.querySelector('.bst-pdp-compra__minis')].filter(Boolean);
      ['pointerdown', 'pointerenter', 'touchstart', 'focusin', 'scroll'].forEach(function (ev) {
        gatilhos.forEach(function (g) { g.addEventListener(ev, carregarAdiadas, { once: true, passive: true }); });
      });
    }
    if (galeria && minis.length) {
      var fotos = galeria.children;
      var passo = function () { return fotos.length > 1 ? fotos[1].offsetLeft - fotos[0].offsetLeft : 1; };
      var marcar = function () {
        var i = Math.max(0, Math.min(minis.length - 1, Math.round(galeria.scrollLeft / passo())));
        minis.forEach(function (m, k) {
          m.classList.toggle('is-ativa', k === i);
          if (k === i) m.setAttribute('aria-current', 'true'); else m.removeAttribute('aria-current');
        });
      };
      var agendado = false;
      galeria.addEventListener('scroll', function () {
        if (agendado) return;
        agendado = true;
        requestAnimationFrame(function () { agendado = false; marcar(); });
      }, { passive: true });
      minis.forEach(function (m, k) {
        m.addEventListener('click', function () { galeria.scrollTo({ left: k * passo(), behavior: 'smooth' }); });
      });
    }

    iniciarStories(raiz);
    iniciarBarraFixa(raiz);
  }

  /* ---------- barra fixa no celular ---------- */
  function iniciarBarraFixa(raiz) {
    var barra = raiz.querySelector('[data-bst-fixo]');
    var botao = raiz.querySelector('form .bst-pdp-compra__botao');
    if (!barra || !botao) return;
    var botaoBarra = barra.querySelector('button');
    var visivel = null;
    /* só depois que o botão principal passou (saiu por cima); antes de chegar nele, a barra fica escondida.
       Conta a cada rolagem (e não por IntersectionObserver, que não avisa quando a rolagem pula o botão de uma vez). */
    function conferir() {
      var sim = botao.getBoundingClientRect().bottom < 0;
      if (sim === visivel) return;
      visivel = sim;
      barra.classList.toggle('is-visivel', sim);
      barra.setAttribute('aria-hidden', sim ? 'false' : 'true');
      if (botaoBarra) botaoBarra.tabIndex = sim ? 0 : -1;
    }
    var agendado = false;
    function agendar() {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(function () { agendado = false; conferir(); });
    }
    window.addEventListener('scroll', agendar, { passive: true });
    window.addEventListener('resize', agendar);
    conferir();
  }

  /* ---------- stories ---------- */
  function iniciarStories(raiz) {
    var botoes = Array.prototype.slice.call(raiz.querySelectorAll('[data-bst-story]'));
    var dialogo = raiz.querySelector('[data-bst-story-dialog]');
    if (!botoes.length || !dialogo) return;
    var palco = dialogo.querySelector('[data-bst-story-palco]');
    var slot = dialogo.querySelector('[data-bst-story-slot]');
    var nome = dialogo.querySelector('[data-bst-story-nome]');
    var progresso = dialogo.querySelector('[data-bst-story-progresso]');
    var ant = dialogo.querySelector('[data-bst-story-ant]');
    var prox = dialogo.querySelector('[data-bst-story-prox]');
    var atual = -1;
    var video = null;

    function limpar() {
      if (video) {
        video.pause();
        Array.prototype.slice.call(video.querySelectorAll('source')).forEach(function (f) { f.remove(); });
        video.removeAttribute('src');
        video.load();
      }
      slot.textContent = '';
      video = null;
      progresso.style.width = '0';
    }

    function mostrar(i) {
      limpar();
      atual = i;
      var botao = botoes[i];
      var modelo = botao.parentNode.querySelector('template[data-bst-story-video]');
      nome.textContent = botao.dataset.nome || '';
      ant.hidden = i === 0;
      prox.hidden = i === botoes.length - 1;
      if (!modelo || !modelo.content.querySelector('video')) return;
      video = modelo.content.querySelector('video').cloneNode(true);
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');
      slot.appendChild(video);
      video.addEventListener('timeupdate', function () {
        if (video && video.duration) progresso.style.width = (100 * video.currentTime / video.duration) + '%';
      });
      video.addEventListener('ended', function () { if (atual < botoes.length - 1) mostrar(atual + 1); else fechar(); });
      var p = video.play();
      if (p && p.catch) p.catch(function () { if (!video) return; video.muted = true; var q = video.play(); if (q && q.catch) q.catch(function () {}); });
    }

    function fechar() { fecharDialogo(dialogo); }

    dialogo.addEventListener('close', function () { limpar(); travarRolagem(false); palco.style.transform = ''; palco.style.opacity = ''; atual = -1; });
    dialogo.addEventListener('click', function (e) { if (e.target === dialogo) fechar(); });
    dialogo.querySelector('[data-bst-story-fechar]').addEventListener('click', fechar);
    ant.addEventListener('click', function () { if (atual > 0) mostrar(atual - 1); });
    prox.addEventListener('click', function () { if (atual < botoes.length - 1) mostrar(atual + 1); });
    slot.addEventListener('click', function () {
      if (arrastou || !video) return;
      if (video.paused) video.play(); else video.pause();
    });

    botoes.forEach(function (b, i) {
      b.addEventListener('click', function () {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'bst_story_toque', story_posicao: i + 1, story_nome: b.dataset.nome || '', pagina: location.pathname });
        } catch (e) { /* medição nunca derruba o vídeo */ }
        try { if (window.clarity) window.clarity('event', 'bst_story_toque'); } catch (e) { /* idem */ }
        abrirDialogo(dialogo);
        mostrar(i);
      });
    });

    /* arrastar para baixo fecha (celular) */
    var y0 = null;
    var dy = 0;
    var arrastou = false;
    palco.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      y0 = e.touches[0].clientY; dy = 0; arrastou = false;
      palco.classList.add('is-arrastando');
    }, { passive: true });
    palco.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      if (dy > 8) arrastou = true;
      palco.style.transform = 'translateY(' + dy + 'px)';
      palco.style.opacity = String(Math.max(0.4, 1 - dy / 600));
    }, { passive: true });
    palco.addEventListener('touchend', function () {
      if (y0 === null) return;
      palco.classList.remove('is-arrastando');
      y0 = null;
      if (dy > 110) { fechar(); } else { palco.style.transform = ''; palco.style.opacity = ''; }
      setTimeout(function () { arrastou = false; }, 50);
    });
  }

  function iniciarTudo() {
    iniciarTabela();
    document.querySelectorAll('[data-bst-pdp-compra]').forEach(iniciarCompra);
    esconderBotoesSemTabela();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarTudo);
  else iniciarTudo();
  document.addEventListener('shopify:section:load', iniciarTudo);
})();
